/**
 * Created by anthony on 7/3/14.
 */


var taxEmailModel = angular.module('taxEmailModel', []);
taxEmailModel.factory('TaxEmailModelFactory', function(ApplicationService, FamilyModelFactory, RestService, $q){
    var TaxEmailModel = function(familyID){
        this.familyID = familyID;
        this.endpoint = "/taxEmail";
        this.primaryKey = "recordID";
    }
    TaxEmailModel.prototype = new FamilyModelFactory();
    TaxEmailModel.prototype.parent = FamilyModelFactory.prototype;

    TaxEmailModel.prototype.resolveData = function(id)
    {
        var parent = this;
        var deferred = $q.defer();
        $q.all([
                RestService.get(this.getEndpoint(this.familyID) + "/" + id),
            ]).then(function (data, status, headers, config, instance) {
                parent.data = data;
                deferred.resolve(data);
        });
        return deferred.promise;
    }
    return TaxEmailModel;
});